import React from 'react';
import { Alert } from '../Alert/Alert';

interface IssuesBannerProps {
  message: string | null;
}

export const IssuesBanner: React.FC<IssuesBannerProps> = (props: IssuesBannerProps) => {
  return (
    <Alert
      severity="error"
      message={
        props.message ??
        'We are currently experiencing issues. Some features may be unavailable or slower than usual. We are working to resolve this and apologise for any inconvenience.'
      }
      dismissable
      position="top"
    />
  );
};
